<mat-expansion-panel (opened)="panelOpen = true" (closed)="panelOpen = false" hideToggle>
    <mat-expansion-panel-header class="py-5 px-4">
        <mat-panel-title class="d-flex">
            <div class="container d-flex flex-column">
                <h2 class="header-title" [class.complete]="touched && this.isStepComplete()" [class.error]="touched && !this.isStepComplete()">{{ title }}</h2>
            </div>
            <div>
                <mat-icon *ngIf="!touched && !panelOpen" class="header-toggle">
                    expand_more
                </mat-icon>
                <mat-icon *ngIf="!touched && panelOpen" class="header-toggle">
                    expand_less
                </mat-icon>
                <mat-icon *ngIf="touched && this.isStepComplete()" class="header-toggle complete">
                    checked
                </mat-icon>
                <mat-icon *ngIf="touched && !this.isStepComplete()" class="header-toggle error">
                    close
                </mat-icon>
           </div>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-container class="step-container">
        <div class="d-flex flex-column ps-4">
            <div *ngIf="displayUploadDocumentsView()">
                <p>
                    Please provide the following photos/documents:
                </p>
            </div>
            <div *ngIf="getFormValue(damageClaimType)">
                <h5 class="mt-4">Damage Claim Documents</h5>
                <ul>
                    <li style="list-style-type: disc; margin-left: 30px">Wide angle photo of the damage</li>
                    <li style="list-style-type: disc; margin-left: 30px">Close-up photo of the damage</li>
                    <li style="list-style-type: disc; margin-left: 30px">Repair or replacement estimates or receipts</li>
                    <li style="list-style-type: disc; margin-left: 30px">Reconciliation of claim amount to receipts if receipts don't total to claim amount</li>
                </ul>
            </div>
            <div *ngIf="getFormValue(theftClaimType)">
                <h5 class="mt-4">Theft Claim Documents</h5>
                <ul>
                    <li style="list-style-type: disc; margin-left: 30px">Police report including list of stolen items</li>
                    <li style="list-style-type: disc; margin-left: 30px">Receipt for replacement item</li>
                </ul>
            </div>
            <div *ngIf="getFormValue(fireClaimType)">
                <h5 class="mt-4">Fire Claim Documents</h5>
                <ul>
                    <li style="list-style-type: disc; margin-left: 30px">Fire report including list of damaged items</li>
                    <li style="list-style-type: disc; margin-left: 30px">Receipt for replacement item</li>
                </ul>
            </div>
            <div *ngIf="getFormValue(bodilyInjuryClaimType)">
                <h5 class="mt-4">Bodily Injury Claim Documents</h5>
                <ul>
                    <li style="list-style-type: disc; margin-left: 30px">Incident Report. Provide a copy of your incident report providing details of accident, witnesses, circumstances, date/time, where injury occurred, contact information for injured party and witnesses</li>
                </ul>
            </div>
            <div *ngIf="getFormValue(otherClaimType)">
                <h5 class="mt-4">Other Documents</h5>
                <ul>
                    <li style="list-style-type: disc; margin-left: 30px">Any relevant photos or documents</li>
                </ul>
            </div>
        </div>
        <div class="d-flex flex-column ps-4">
            <div *ngFor="let section of supportingDocumentSections">
                <app-supporting-document-section 
                    [supportingDocumentSection]="section" 
                    (deleteEvent)="onDeleteSection($event)"
                    (sectionUpdatedEvent)="onSectionUpdated()"
                ></app-supporting-document-section>
            </div>
            <button mat-raised-button class="action-button w-fit mt-2" (click)="addSection()" [disabled]="!canAddSection()">
                <mat-icon>add</mat-icon>
                Add Documents
            </button>
        </div>
        <div *ngIf="existingSupportingDocuments$.value.length > 0" class="d-flex flex-column ps-4">
            <hr />
            <h4 class="mt-2">Previously Uploaded Documents</h4>
            <table mat-table [dataSource]="dataSource" style="overflow-x: auto; overflow-y: hidden;">
                <ng-container matColumnDef="image">
                    <th mat-header-cell *matHeaderCellDef>Preview</th>
                    <td mat-cell *matCellDef="let document" [id]="document.id" #imageRef class="my-2 py-4 d-flex justify-content-center">
                        <mat-icon 
                            style="transform: scale(3)"
                            *ngIf="!imageUtility.isImage(document.fileName); else documentPreview"
                        >
                            insert_drive_file
                        </mat-icon>
                        <ng-template #documentPreview>
                            <img [src]="document.fileData" style="width: 100%; max-width: 250px; padding: 10px" />
                        </ng-template>
                    </td>
                </ng-container>

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef> Name </th>
                    <td mat-cell *matCellDef="let document"> {{document.fileName}} </td>
                </ng-container>

                <ng-container matColumnDef="description">
                    <th mat-header-cell *matHeaderCellDef> Description </th>
                    <td mat-cell *matCellDef="let document"> {{document.description}} </td>
                </ng-container>

                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let document">
                        <button mat-icon-button (click)="onEditClick(document)">
                            <mat-icon>edit</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>
            <mat-paginator 
                [pageSizeOptions]="[10, 20, 50, 100]"
                showFirstLastButtons
                aria-label="Select page of periodic elements"
            >
            </mat-paginator>
        </div>
        <div class="my-3 ps-4" *ngIf="invalidSupportingDocumentNames.length > 0">
            <mat-icon style="color: red" class="mr-2">warning</mat-icon>
            The following files documents not be loaded, please re-upload them. Attachments will be removed from the claim after the claim is saved/submitted again:
            <ul class="mx-4" style="list-style: initial">
                <li *ngFor="let name of invalidSupportingDocumentNames">{{ name }}</li>
            </ul>
        </div>
        <div class="d-flex flex-column my-3 ps-4">
            <span><strong>*** In order to provide you with the best service, please provide as much documentation as you can. The more photos you provide, the better. ***</strong></span>
        </div>
    </ng-container>
</mat-expansion-panel>